import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import { Notification, SelectField } from "@wk/components-react16";
import LoadingSpinner from "components/loading/LoadingSpinner";
import { getContactSelection } from "services/csa-api/csaThunk";
import { csaSelector } from "services/csa-api/csaSlice";
import ContactSelection from "./ui/ContactSelection";

export const Contact = () => {
  const dispatch = useDispatch();
  const updateUrl = useNavigate();
  const { category, topic } = useParams();
  const { isLoading } = useSelector(csaSelector);
  const clientId = sessionStorage.getItem("clientId");
  const [selection, setSelection] = useState([]);
  const [categoryId, setCategoryId] = useState(0);
  const [topicId, setTopicId] = useState(0);
  const [notification, showNotification] = useState(false);
  const location = useLocation();
  const queryParameters = new URLSearchParams(location.search);
  const temp_product = queryParameters.get("contact_product");
  if (temp_product) {
    sessionStorage.setItem("contact_product", temp_product);
  }
  const wkn = queryParameters.get("wkn");
  if (wkn) {
    sessionStorage.setItem("wkn", wkn);
  }

  useEffect(() => {
    dispatch(getContactSelection(clientId)).then(res => {
      applySelection(res.payload);
    });
  }, []);

  useEffect(() => {
    applySelection(selection);
  }, [category, topic]);

  const applySelection = (formSelection) => {
    setSelection(formSelection);
    const categoryObject = formSelection.find(item => item.cPath === category);
    if (categoryObject) {
      setCategoryId(categoryObject.cId);
      const topicObject = categoryObject.topics.find(item => item.tPath === topic);
      if (topicObject) {
        setTopicId(topicObject.tId);
      }
    }
  }

  const navigateToUrl = (category, topic) => {
    if (!category) {
      setCategoryId(0);
      setTopicId(0);
      updateUrl("/kontakt");
    } else if (!topic) {
      setTopicId(0);
      updateUrl(`/kontakt/${category}`);
    } else {
      updateUrl(`/kontakt/${category}/${topic}`);
    }
  }

  const messageSent = () => {
    showNotification(true);
    navigateToUrl(null, null);
    window.scrollTo(0, 0);
  };

  return (
    <>
      { isLoading ? (
        <>
          <LoadingSpinner/>
        </>
      ) : (
        <>
          <div className="wk-form wk-form-contact-selection" id="form-contact-selection">
            <Notification
              type="success"
              heading="Wir haben Ihre Anfrage erhalten und Sie erhalten eine E-Mail als Eingangsbestätigung mit Ticketnummer."
              hasCloseButton={true}
              isOpen={notification}
              onCloseEnd={() => showNotification(false)}
              autoCloseTimeout={0}
            ></Notification>
            <h1>Kontakt - Wir helfen gerne</h1>
            <p>
              Individuelle Betreuung bei vertraglichen Rückfragen, technischen Problemen oder Anregungen.
            </p>
            <div className="form-selection-wrapper">
              <SelectField
                key="category"
                label="Wobei können wir Ihnen weiterhelfen?"
                labelFor="form-select-category"
                className="wk-contact-form-select"
              >
                <select
                  id="form-select-category"
                  name="category"
                  onChange={() => {
                    navigateToUrl(document.getElementById("form-select-category").value, null);
                  }}>
                  <option key={0} value="" selected={categoryId === 0}>
                    - Bitte wählen Sie ein Thema aus -
                  </option>
                  {selection.map((element) => {
                    return (
                      <option key={element.cId} value={element.cPath} selected={categoryId === element.cId}>
                        {element.cLabel}
                      </option>
                    );
                  })}
                </select>
              </SelectField>
              { categoryId !== 0 && <>
                <SelectField
                  key="topic"
                  label="Bitte wählen Sie Ihr konkretes Anliegen aus."
                  labelFor="form-select-topic"
                >
                  <select
                    id="form-select-topic"
                    name="topic"
                    onChange={() => {
                      navigateToUrl(
                        document.getElementById("form-select-category").value,
                        document.getElementById("form-select-topic").value,
                      );
                    }}>
                    <option key={0} value="" selected={topicId === 0} hidden>
                      - Bitte auswählen -
                    </option>
                    {selection.find(item => item.cId === categoryId).topics.map((element) => {
                      return (
                        <option key={element.tId} value={element.tPath} selected={topicId === element.tId}>
                          {element.tLabel}
                        </option>
                      );
                    })}
                  </select>
                </SelectField>
              </>}
            </div>
            { topicId !== 0 && <>
              <ContactSelection cid={categoryId} tid={topicId} messageSent={messageSent}/>
            </>}
          </div>
        </>
      )}
    </>
  );
}

export default Contact;
